import Axios from '@/config/AxiosConfig';

export const getAutoCompleteResults = async (query, type, limit,contactTypeId, groupId, tenancyId, propertyId, saleId) => {
    const contactTypeIdStr = contactTypeId ? '&contact_type_id='+contactTypeId:'';
    const groupIdStr = groupId ? `&group_id=${groupId}` : '';
    const tenancyIdStr = tenancyId ? `&tenancy_id=${tenancyId}` : '';
    const propertyIdStr = propertyId ? `&property_id=${propertyId}` : '';
    const propertySaleId = saleId ? `&sale_id=${saleId}` : '';
    const url = `/auto-complete?search_string=${query}&type=${type}${groupIdStr}&limit=${limit}${contactTypeIdStr}${tenancyIdStr}${propertyIdStr}${propertySaleId}`;
    // const url = `/auto-complete?search_string=${query}&type=${type}&limit=${limit}${contactTypeIdStr}`;
    try {
        const { data } = await Axios.get(url);
        // console.log(data, 'autocomplete data');
        return data;
    } catch (e) {
        return e.response;
    }
};
